// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__289Di","productName":"Table_productName__1RG5M"};